export function isMobileDevice() {
  const userAgent = navigator.userAgent;

  const mobileRegex =
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|rim)|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i;

  const tabletRegex = /android|ipad|playbook|silk/i;

  return mobileRegex.test(userAgent) || tabletRegex.test(userAgent);
}

export function isIOS() {
  const userAgent = navigator.userAgent;

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return true;
  }

  if (
    navigator.maxTouchPoints > 1 &&
    /Safari/.test(userAgent) &&
    !/Chrome|Android/.test(userAgent)
  ) {
    return true;
  }

  return false;
}
